import { throttle } from 'lodash';

const siteNotice = () => {
  const notice = document.querySelector('.siteNotice');

  // Make sure we have a notice
  if (!notice) return;

  const closeBtn = document.querySelector('.siteNotice-closeBtnWrap');
  const noticeId = closeBtn.dataset.closeNotice;

  closeBtn.addEventListener('click', () => {
    notice.parentNode.removeChild(notice);
    localStorage.setItem('notice-closed', noticeId);
  });
};

siteNotice();

const getDocHeight = () => {
  const D = document;
  return Math.max(
    D.body.scrollHeight,
    D.documentElement.scrollHeight,
    D.body.offsetHeight,
    D.documentElement.offsetHeight,
    D.body.clientHeight,
    D.documentElement.clientHeight,
  );
};

const amountscrolled = () => {
  const notice = document.querySelector('.siteNotice');
  if (!notice) return;

  const winheight = window.innerHeight || (document.documentElement || document.body).clientHeight;
  const docheight = getDocHeight();
  const scrollTop =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body).scrollTop;
  const trackLength = docheight - winheight;
  const pctScrolled = Math.floor((scrollTop / trackLength) * 100); // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)

  if (pctScrolled > 10) {
    notice.classList.add('unstick');
  } else {
    notice.classList.remove('unstick');
  }
};

window.addEventListener('scroll', throttle(amountscrolled, 500));
